import '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import { getUrl } from '../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';

function useBloomreachLinks(links = []) {
    const page = useBrPageContext();
    return mapBloomreachLinks(links, page);
}
const mapBloomreachLinks = (links, page)=>{
    var ref;
    return links.map(({ url , label , style , openInNewWindow  })=>({
            label,
            style,
            url: (ref = getUrl(url, page)) !== null && ref !== void 0 ? ref : '',
            target: openInNewWindow ? 'external' : 'internal'
        })
    );
};

export { mapBloomreachLinks, useBloomreachLinks };
//# sourceMappingURL=use-bloomreach-links.js.map
